import { useState } from 'react';

const usePopover = () => {
  // HOOKS
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const handleOpenPopover = () => {
    setIsPopoverOpen(true);
  };

  const handleClosePopover = () => {
    setIsPopoverOpen(false);
  };

  const handleTogglePopover = () => {
    setIsPopoverOpen(!isPopoverOpen);
  };

  const handleChangePopoverOpen = (isOpen: boolean) => {
    setIsPopoverOpen(isOpen);
  };

  return {
    // STATE
    isPopoverOpen,

    // HANDLERS
    handleOpenPopover,
    handleClosePopover,
    handleTogglePopover,
    handleChangePopoverOpen,
  };
};

export default usePopover;
